import adminTable from "@store/adminTable/reducers";

import { options_category } from "@Modules/Options/configs/constants";

export default adminTable(options_category);
